import { useState, useEffect, useRef } from "react";

import CircularProgressWithLabel from "@/components/SiteIcons/CircularProgressWithLabel";

function CircularLoaderWithPercentage({ totalSeconds }) {
  // tracker was a `let` variable reassigned inside useEffect, which was
  // reset every render. Use a ref so the counter survives across renders.
  const tracker = useRef(0);
  const [numerator, setNumerator] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      tracker.current += 1;
      if (tracker.current >= totalSeconds) {
        tracker.current *= 0.5;
      }
      setNumerator(tracker.current);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [totalSeconds]);

  useEffect(() => {
    const percentCompleted = Math.min(
      Math.floor((numerator / totalSeconds) * 100),
      100 // small files can simply reach 100%
    );
    setProgress(percentCompleted);
  }, [numerator, totalSeconds]);

  return <CircularProgressWithLabel progress={progress} />;
}

export default CircularLoaderWithPercentage;
